import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const McoPhsCapChart = ({ formValues }) => {

    const { mcoInvId, prodIds, periodIds } = formValues;

    const rsrc = useRsrc();

    const { navigateTo } = useNavState();

    const [data, setData] = useState([]);

    useEffect(() => {
        if (!mcoInvId) {
            return;
        }

        const reqParam = {
            mcoInvId,
            prodIds,
            periodIds
        };

        rsrc.data('sc', 'MCO_PHS_CAP_CHART_DATA_PLUGIN', reqParam).then(res => {
            setData(res);
        });
    }, [mcoInvId, prodIds, periodIds]);

    const navigateToInvLineList = (dataPoint) => {
        const key = dataPoint.category;

        const [periodCode, prodCode] = key.split(' & ');

        const svcDates = [];
        for (let i = 1; i <= 31; i++) {
            const day = periodCode.substring(0, 4) + periodCode.substring(5, 7) + i.toString().padStart(2, '0');
            svcDates.push(parseInt(day));
        }
        const navState = {
            expr: ExprUtils.whereParams('mcoInvId', mcoInvId, 'svcDate', svcDates, 'extNdc11', prodCode, 'brgMatched', true)
        };
        navigateTo('sc/mco-inv-line', navState);
    }

    return (
        <>
            <CartesianChart 
                data={data}
                yLabel="Amount Disputed"
                xLabel="Fill Date and Product"
                stacked={true}
                onClick={(dataPoint) => navigateToInvLineList(dataPoint)}
            />
        </>
    )

}